<template>
    <section class="country-slider-section l-primary-bg pt-0 overflow-hidden">
            <div class="container-fluid">
                <div class="row mb-5 " v-if="showHeading">
                    <div class="page-title title-m text-center"> 
                        <h2 class="d-hex-color fw-semibold">Discover Cultures</h2>
                    </div>
                </div>
                <div class="row">
                    <Carousel
                      :items-to-show="1"
                      :wrap-around="true"
                      :autoplay="1500"
                      :breakpoints="{ 481: { itemsToShow: 2 }, 601: { itemsToShow: 3 }, 1025: { itemsToShow: 4 } }"
                      class="country-slider m-0 p-0"
                    >
                      <Slide v-for="(content, index) in cultures" :key="index">
                        <article @click="goToCultureInfo(content.culture)" class="position-relative overflow-hidden mx-1 w-100">
                            <span class="country-slider-img overlay-before overflow-hidden position-relative">
                                <img :src="`${MEDIA_BASEURL}${content.media.mediumBanner}`" alt="img">
                            </span>
                            <span class="country-slider-title text-center text-white fw-semibold">{{ content.culture }}</span>
                        </article>
                      </Slide>
                    </Carousel>
                </div>
            </div>
        </section>
</template>

<script setup>
import ApiClient from "@/methods/apiclient";
import { onMounted, ref } from "vue";
import { MEDIA_BASEURL } from "@/utils/constants";
import { useRouter } from "vue-router";
import { createSeoFriendlyUrl } from "@/utils/helpers";
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import { ROUTES } from "@/utils/constants/routes";
const router = useRouter()

const props = defineProps({
  showHeading:{
    type:Boolean,
    default:false
  },
  limit:{
    type:Number,
    default:999999999
  }
})

const goToCultureInfo = (culture) =>{
    router.push({name:ROUTES.CULTURE_INFO,params:{culture: createSeoFriendlyUrl(culture)}}).then(() => {
      location.href = window.location.href; // Force reload by updating the URL
    });
}

const cultures = ref([]);

onMounted(async () => {
  try {
    const response = await ApiClient.get('content/all', { page: 1, searchQuery: '', limit: props.limit });
    cultures.value = [...response.data];
  } catch (error) {
    // Handle errors
  }
});
</script>
